// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wCA9B","content":"styles_content__2rESm"};